module.exports = __webpack_public_path__ + "img/photo-5.101043a9.jpg";